var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"fv-list",attrs:{"tabindex":_vm.tabindex,"data-parent":_vm.parent}},[(_vm.$scopedSlots.default || _vm.$slots.default)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/framevuerk-builder/node_modules/pug-html-loader/lib!./node_modules/framevuerk-builder/node_modules/vue-loader/lib??vue-loader-options!./src/components/fvList.vue?vue&type=template&id=a9093e24&lang=pug&
// module id = 116
// module chunks = 0 1